import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'General Health Checkups',
      description: 'Comprehensive physical examinations and routine health screenings are essential for maintaining your overall wellness and detecting potential health issues early.',
      details: [
        'Complete physical examination',
        'Vital signs monitoring (blood pressure, heart rate, temperature)',
        'Blood work and laboratory tests',
        'Health risk assessment',
        'Lifestyle and nutrition counseling',
        'Age-appropriate screening recommendations'
      ],
      image: 'https://public.readdy.ai/ai/img_res/f35d7e92af2edb7d61a174fb4abb4177.jpg'
    },
    {
      icon: 'ri-medicine-bottle-line',
      title: 'Chronic Disease Management',
      description: 'Expert ongoing care for chronic conditions including diabetes, hypertension, heart disease, and other long-term health conditions requiring continuous monitoring and treatment.',
      details: [
        'Diabetes management and blood sugar monitoring',
        'Hypertension control and cardiovascular care',
        'Asthma and respiratory condition management',
        'Thyroid disorder treatment',
        'Arthritis and pain management',
        'Regular monitoring and medication adjustment',
        'Lifestyle modification guidance',
        'Complication prevention strategies'
      ],
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20professional%20monitoring%20chronic%20disease%20patient%20with%20medical%20equipment%20and%20charts%2C%20diabetes%20blood%20sugar%20testing%2C%20hypertension%20care%2C%20modern%20medical%20clinic%2C%20professional%20healthcare%20management%2C%20patient%20education%2C%20simple%20clean%20background&width=800&height=600&seq=service-chronic&orientation=landscape'
    },
    {
      icon: 'ri-syringe-line',
      title: 'Vaccinations & Immunizations',
      description: 'Complete vaccination services for all ages, protecting you and your family from preventable diseases with up-to-date immunization schedules.',
      details: [
        'Childhood immunization programs',
        'Adult vaccination schedules',
        'Flu shots (seasonal influenza vaccine)',
        'COVID-19 vaccinations and boosters',
        'Travel vaccines and consultations',
        'Tetanus and booster shots',
        'Shingles and pneumonia vaccines',
        'HPV and meningitis vaccines'
      ],
      image: 'https://readdy.ai/api/search-image?query=Medical%20professional%20preparing%20vaccination%20injection%20syringe%20in%20clean%20modern%20clinic%2C%20immunization%20service%2C%20vaccine%20administration%2C%20professional%20healthcare%20setting%2C%20medical%20supplies%2C%20bright%20lighting%2C%20sterile%20environment%2C%20patient%20safety&width=800&height=600&seq=service-vaccine&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Preventive Care Programs',
      description: 'Proactive health strategies designed to prevent illness and maintain optimal health through regular screenings, lifestyle counseling, and early intervention.',
      details: [
        'Cancer screening programs (breast, cervical, colorectal)',
        'Cardiovascular disease prevention',
        'Osteoporosis screening and prevention',
        'Weight management and obesity prevention',
        'Smoking cessation programs',
        'Nutrition and dietary counseling',
        'Exercise and fitness planning',
        'Stress management techniques'
      ],
      image: 'https://readdy.ai/api/search-image?query=Preventive%20healthcare%20consultation%20with%20doctor%20and%20patient%20discussing%20wellness%20plan%2C%20health%20screening%2C%20lifestyle%20counseling%2C%20modern%20medical%20office%2C%20professional%20medical%20advice%2C%20healthy%20living%20guidance%2C%20bright%20clean%20environment&width=800&height=600&seq=service-preventive&orientation=landscape'
    },
    {
      icon: 'ri-surgical-mask-line',
      title: 'Minor Procedures',
      description: 'In-office minor surgical procedures and treatments performed in a comfortable, safe clinical setting with proper sterile techniques.',
      details: [
        'Wound care and suturing',
        'Abscess drainage',
        'Skin lesion and mole removal',
        'Wart treatment and removal',
        'Ingrown toenail treatment',
        'Joint injections for pain relief',
        'Ear irrigation and foreign body removal',
        'Minor burn and injury treatment'
      ],
      image: 'https://readdy.ai/api/search-image?query=Medical%20professional%20performing%20minor%20surgical%20procedure%20in%20sterile%20clinic%20environment%2C%20wound%20care%20treatment%2C%20medical%20instruments%2C%20professional%20healthcare%20setting%2C%20clean%20white%20background%2C%20proper%20medical%20technique%2C%20patient%20safety&width=800&height=600&seq=service-procedures&orientation=landscape'
    },
    {
      icon: 'ri-hospital-line',
      title: 'Specialist Referrals',
      description: 'Coordinated referrals to trusted specialists when advanced or specialized care is needed, ensuring seamless continuity of your treatment and care.',
      details: [
        'Cardiology referrals',
        'Endocrinology consultations',
        'Orthopedic specialist referrals',
        'Dermatology appointments',
        'Mental health professional referrals',
        'Gastroenterology consultations',
        'Referral coordination and follow-up',
        'Medical records transfer and communication'
      ],
      image: 'https://readdy.ai/api/search-image?query=Doctor%20reviewing%20patient%20medical%20records%20and%20specialist%20referral%20documents%20in%20modern%20medical%20office%2C%20healthcare%20coordination%2C%20professional%20consultation%2C%20medical%20charts%2C%20collaborative%20care%2C%20clean%20professional%20environment&width=800&height=600&seq=service-referral&orientation=landscape'
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Mental Health Support',
      description: 'Compassionate mental health care including assessment, counseling, and treatment for anxiety, depression, and other mental health concerns.',
      details: [
        'Depression and anxiety screening',
        'Mental health counseling',
        'Stress and burnout management',
        'Sleep disorder evaluation',
        'Medication management for mental health',
        'Referrals to mental health specialists',
        'Crisis intervention support',
        'Ongoing mental wellness monitoring'
      ],
      image: 'https://readdy.ai/api/search-image?query=Compassionate%20doctor%20providing%20mental%20health%20consultation%20and%20counseling%20in%20comfortable%20private%20office%2C%20supportive%20healthcare%20environment%2C%20professional%20therapy%20session%2C%20calming%20atmosphere%2C%20patient%20wellbeing%2C%20simple%20clean%20background&width=800&height=600&seq=service-mental&orientation=landscape'
    },
    {
      icon: 'ri-parent-line',
      title: 'Women\'s Health Services',
      description: 'Comprehensive women\'s health care including reproductive health, prenatal care, and health screenings specific to women\'s needs.',
      details: [
        'Annual gynecological examinations',
        'Pap smears and cervical cancer screening',
        'Breast health and mammography referrals',
        'Contraception counseling and prescriptions',
        'Prenatal care and pregnancy monitoring',
        'Menopause management',
        'Fertility consultations',
        'Sexual health counseling'
      ],
      image: 'https://readdy.ai/api/search-image?query=Female%20doctor%20providing%20women%5Cs%20health%20consultation%20in%20modern%20medical%20clinic%2C%20gynecological%20care%2C%20professional%20healthcare%20for%20women%2C%20comfortable%20private%20examination%20room%2C%20supportive%20medical%20environment%2C%20clean%20professional%20setting&width=800&height=600&seq=service-womens&orientation=landscape'
    },
    {
      icon: 'ri-empathize-line',
      title: 'Pediatric Care',
      description: 'Specialized care for infants, children, and adolescents including well-child visits, developmental assessments, and treatment of childhood illnesses.',
      details: [
        'Well-child checkups and growth monitoring',
        'Childhood immunizations',
        'Developmental milestone assessments',
        'Treatment of common childhood illnesses',
        'School and sports physicals',
        'Adolescent health and puberty guidance',
        'Behavioral and learning concern evaluation',
        'Parenting support and education'
      ],
      image: 'https://readdy.ai/api/search-image?query=Friendly%20pediatric%20doctor%20examining%20happy%20child%20patient%20in%20colorful%20welcoming%20medical%20clinic%2C%20pediatric%20healthcare%2C%20child-friendly%20environment%2C%20professional%20medical%20care%20for%20children%2C%20parent%20present%2C%20bright%20cheerful%20atmosphere&width=800&height=600&seq=service-pediatric&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Our Medical Services
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Comprehensive healthcare services designed to meet all your medical needs, from preventive care to chronic disease management
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="space-y-20">
            {services.map((service, index) => (
              <div 
                key={index}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl mb-6">
                    <i className={`${service.icon} text-4xl text-white`}></i>
                  </div>
                  
                  <h2 className="font-serif text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h2>
                  
                  <p className="text-lg text-gray-700 leading-relaxed mb-6">
                    {service.description}
                  </p>

                  <div className="bg-gray-50 rounded-xl p-6 mb-6">
                    <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-checkbox-circle-line text-blue-600"></i>
                      What's Included:
                    </h3>
                    <ul className="space-y-3">
                      {service.details.map((detail, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <i className="ri-arrow-right-s-line text-blue-600 text-xl flex-shrink-0 mt-0.5"></i>
                          <span className="text-gray-700">{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link
                    to="/#booking-section"
                    className="inline-block bg-blue-900 hover:bg-blue-800 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap"
                  >
                    Book This Service
                  </Link>
                </div>

                <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl font-bold text-gray-900 mb-4">
              Additional Services
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              We offer many more services to support your complete health and wellness
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-plane-line', title: 'Travel Medicine', desc: 'Pre-travel consultations and vaccines' },
              { icon: 'ri-football-line', title: 'Sports Physicals', desc: 'Athletic clearance examinations' },
              { icon: 'ri-file-text-line', title: 'Medical Forms', desc: 'Work and insurance documentation' },
              { icon: 'ri-first-aid-kit-line', title: 'Urgent Care', desc: 'Same-day acute illness treatment' },
              { icon: 'ri-heart-add-line', title: 'Health Coaching', desc: 'Personalized wellness guidance' },
              { icon: 'ri-capsule-line', title: 'Medication Review', desc: 'Prescription management and optimization' },
              { icon: 'ri-test-tube-line', title: 'Lab Services', desc: 'On-site blood work and testing' },
              { icon: 'ri-phone-line', title: 'Telehealth', desc: 'Virtual consultations available' }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                  <i className={`${item.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-900 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-serif text-4xl font-bold mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            Book an appointment today and experience comprehensive, compassionate healthcare tailored to your needs.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/#booking-section"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Book an Appointment
            </Link>
            <a 
              href="tel:+14165551234"
              className="bg-white hover:bg-gray-100 text-blue-900 px-8 py-4 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Call (416) 555-1234
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
